import { useMutation } from "@tanstack/react-query";
import artificialInstance from "api/aiInstance";

type SendMessageInput = {
    message: {
        role: "user" | "ai";
        content: string;
    };
    risk_context?: {
        class_of_business?: string;
        insured_name?: string;
        occupancy?: string;
        sum_insured?: {
            amount?: Number;
            currency?: string;
        };
        location?: {
            country?: string;
            region?: string;
            city?: string;
            coordinates?: [null, null];
        };
        retention_strategy?: string;
        offer_id?: string;
        proposed_share_pct?: 0;
    };
    attachment_doc_ids?: [string];
};

const useSendChatMessage = () => {
    const { mutateAsync, data, isPending } = useMutation({
        mutationKey: ["send-chat-message"],
        mutationFn: async (data: SendMessageInput) => {
            const result = await artificialInstance.post(`v1/chat`, data);
            return result?.data;
        },
    });
    return {
        sendMessage: mutateAsync,
        response: data,
        isLoading: isPending,
    };
};

export default useSendChatMessage;
